/* unplugin-vue-components disabled */import { render } from "./account_security.vue?vue&type=template&id=51712754&scoped=true"
import script from "./account_security.vue?vue&type=script&lang=js"
export * from "./account_security.vue?vue&type=script&lang=js"

import "./account_security.vue?vue&type=style&index=0&id=51712754&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51712754"]])

export default __exports__